import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.23 17.296a6.197 6.197 0 0 1-.961-.259c-.668-.239-1.002-.358-1.13-.388-1.183-.279-1.674.532-2.693.702a.78.78 0 0 1-.905-.832c.037-.443.343-.861.465-1.286.253-.883-.091-1.552-.455-2.338A7.792 7.792 0 0 1 16.236 5.5m-6.153 8.25a5.5 5.5 0 0 0 5.5 5.5 4.84 4.84 0 0 0 1.663-.268c.472-.168.708-.253.798-.274.835-.196 1.181.376 1.901.496a.55.55 0 0 0 .639-.588c-.026-.312-.242-.607-.328-.907-.18-.624.064-1.096.32-1.65a5.5 5.5 0 1 0-10.493-2.308Z"
    />
  </svg>
)
export default SvgComponent
